import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';

export const SiteTemplate = ({
  description,
  title,
  helmet,
  image,
  siteurl,
  sitecategory,
  sitefburl,
  sitetwurl,
  shopifyplus,
}) => {
  return (
    <div className="site-details">
      <div className="wrapper">
        {helmet || ''}
        <div className="site-details-inner">
          <div className="site-details-image">
            <img src={image} alt={title} />
          </div>
          <div className="site-details-content">
            <h1>{title}</h1>
            <div className="site-details-link">
              <a href={`http://${siteurl}`} target="_blank" rel="noreferrer">
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  className="bi bi-box-arrow-up-right"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                  />
                  <path
                    fillRule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                  />
                </svg>
                {siteurl}
              </a>
            </div>
            <h2>
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                className="bi bi-tag"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M2 2v4.586l7 7L13.586 9l-7-7H2zM1 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2z"
                />
                <path
                  fillRule="evenodd"
                  d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                />
              </svg>
              {sitecategory}
            </h2>
            <p>{description}</p>
            <div className="site-details-social-icon">
              <div>
                <a href={sitefburl} target="_blank" rel="noreferrer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 291.319 291.319"
                  >
                    <path
                      d="M145.659 0c80.45 0 145.66 65.219 145.66 145.66 0 80.45-65.21 145.659-145.66 145.659S0 226.109 0 145.66C0 65.219 65.21 0 145.659 0z"
                      fill="#3b5998"
                    />
                    <path
                      d="M163.394 100.277h18.772v-27.73h-22.067v.1c-26.738.947-32.218 15.977-32.701 31.763h-.055v13.847h-18.207v27.156h18.207v72.793h27.439v-72.793h22.477l4.342-27.156h-26.81v-8.366c0-5.335 3.55-9.614 8.603-9.614z"
                      fill="#fff"
                    />
                  </svg>
                </a>
                <a href={sitetwurl} target="_blank" rel="noreferrer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 112.197 112.197"
                  >
                    <circle cx="56.099" cy="56.098" r="56.098" fill="#55acee" />
                    <path
                      d="M90.461 40.316a26.753 26.753 0 01-7.702 2.109 13.445 13.445 0 005.897-7.417 26.843 26.843 0 01-8.515 3.253 13.396 13.396 0 00-9.79-4.233c-7.404 0-13.409 6.005-13.409 13.409 0 1.051.119 2.074.349 3.056-11.144-.559-21.025-5.897-27.639-14.012a13.351 13.351 0 00-1.816 6.742c0 4.651 2.369 8.757 5.965 11.161a13.314 13.314 0 01-6.073-1.679l-.001.17c0 6.497 4.624 11.916 10.757 13.147a13.362 13.362 0 01-3.532.471c-.866 0-1.705-.083-2.523-.239 1.706 5.326 6.657 9.203 12.526 9.312a26.904 26.904 0 01-16.655 5.74c-1.08 0-2.15-.063-3.197-.188a37.929 37.929 0 0020.553 6.025c24.664 0 38.152-20.432 38.152-38.153 0-.581-.013-1.16-.039-1.734a27.192 27.192 0 006.692-6.94z"
                      fill="#f1f2f2"
                    />
                  </svg>
                </a>
              </div>
              <div className="site-item-content-svg">
                <a
                  href="https://www.shopify.com/plus"
                  target="_blank"
                  rel="noreferrer"
                >
                  {shopifyplus ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 108.197 32.086"
                    >
                      <path
                        fill="#282828"
                        d="M-1.777-1.145h110.75v34.188H-1.777z"
                      />
                      <path fill="#282828" d="M0-.024h108.197v32.11H0z" />
                      <path
                        fill="#FFF"
                        d="M17.227 18.926c.424.217 1.186.516 1.91.5.659 0 1.015-.352 1.015-.781 0-.416-.253-.697-.964-1.098-.88-.496-1.54-1.195-1.54-2.109 0-1.61 1.403-2.756 3.449-2.756.896 0 1.588.167 1.959.382l-.54 1.627a3.518 3.518 0 00-1.452-.316c-.657 0-1.081.298-1.081.764 0 .363.305.631.896.945.912.516 1.67 1.212 1.67 2.193 0 1.826-1.502 2.854-3.598 2.838-.964-.016-1.86-.264-2.3-.562l.576-1.627zM23.024 21.072l2.264-11.627h2.333l-.896 4.508.034-.031c.625-.729 1.438-1.233 2.468-1.233 1.217 0 1.91.769 1.91 2.063 0 .397-.066 1.042-.17 1.541l-.912 4.779h-2.332l.878-4.635a5.4 5.4 0 00.103-1.04c0-.499-.202-.859-.73-.859-.742 0-1.537.976-1.841 2.487l-.776 4.049h-2.333v-.002zM34.129 17.879c0 .832.338 1.496 1.133 1.496 1.234 0 1.927-2.16 1.927-3.572 0-.681-.271-1.377-1.098-1.377-1.27 0-1.962 2.14-1.962 3.453m5.442-2.01c0 2.839-1.86 5.267-4.614 5.267-2.096 0-3.211-1.432-3.211-3.207 0-2.773 1.856-5.265 4.664-5.265 2.18 0 3.16 1.562 3.16 3.205M42.344 19.076c.253.199.54.33.963.33 1.303 0 2.196-2.105 2.196-3.586 0-.614-.22-1.262-.93-1.262-.811 0-1.572.946-1.844 2.375l-.385 2.143zm-3.33 5.228l1.623-8.381c.187-.946.37-2.172.474-3.033h2.062l-.136 1.292h.035c.625-.861 1.538-1.439 2.468-1.439 1.707 0 2.397 1.339 2.397 2.884 0 2.79-1.791 5.538-4.526 5.538-.576 0-1.102-.093-1.37-.308h-.051l-.645 3.445-2.331.002zM51.03 12.029c-.658 0-1.1-.554-1.1-1.234 0-.749.593-1.374 1.335-1.374.709 0 1.166.55 1.166 1.214-.016.847-.642 1.396-1.368 1.396l-.032-.002zm-3.025 9.043l1.573-8.182h2.349l-1.588 8.182H48.005zM52.366 21.072l1.232-6.458h-1.082l.338-1.724h1.08l.069-.411c.188-.964.558-1.942 1.354-2.606.625-.529 1.452-.771 2.28-.771.574 0 .996.079 1.27.194l-.457 1.792a2.352 2.352 0 00-.742-.116c-.777 0-1.252.728-1.387 1.508l-.084.412h1.623l-.321 1.723h-1.606L54.7 21.074h-2.333l-.002-.002zM60.748 12.891l.373 3.664c.102.812.169 1.506.202 1.937h.033c.187-.431.354-1.072.69-1.951l1.422-3.646h2.436l-2.857 5.99c-1.014 2.06-1.994 3.562-3.06 4.539-.827.765-1.81 1.144-2.282 1.24l-.644-1.945c.39-.133.88-.334 1.319-.647.54-.365.996-.863 1.269-1.379.067-.117.084-.195.052-.361l-1.404-7.436 2.45-.005z"
                      />
                      <path
                        fill="#D09D26"
                        d="M69.337 20.412c-1.761 0-2.457-1.191-2.016-3.449.444-2.275 1.562-3.43 3.312-3.43 1.914 0 2.623 1.122 2.17 3.43-.458 2.353-1.56 3.449-3.466 3.449m1.494-7.624c-1.203 0-2.19.412-2.894 1.199l.137-.694a.329.329 0 00-.332-.404.526.526 0 00-.492.404l-2.078 10.605c-.043.219.109.403.333.403s.448-.186.49-.403l.772-3.939c.285.504.943 1.193 2.425 1.193 1.157 0 2.13-.351 2.889-1.039.779-.713 1.313-1.773 1.585-3.152.27-1.376.15-2.434-.354-3.142-.487-.683-1.323-1.032-2.481-1.031M88.768 16.516c-1.044-.38-2.028-.739-1.842-1.695.094-.481.49-1.287 2.09-1.287.9 0 1.468.244 1.959.843a.29.29 0 00.242.112c.205 0 .41-.17.45-.372a.335.335 0 00-.048-.259l-.007-.01c-.5-.701-1.323-1.057-2.45-1.057-1.645 0-2.814.777-3.062 2.031-.294 1.5 1.058 2 2.247 2.444 1.03.383 2.004.743 1.824 1.661-.254 1.296-1.635 1.486-2.438 1.486-1.104 0-1.785-.295-2.28-.986-.002-.002-.003-.006-.005-.006a.308.308 0 00-.242-.11.48.48 0 00-.45.368.34.34 0 00.048.261c.329.604 1.318 1.219 2.785 1.219 1.859 0 3.134-.834 3.407-2.229.29-1.489-1.05-1.979-2.23-2.409M86.278 10.696h-.87l.167-.854a.328.328 0 00-.332-.404.527.527 0 00-.492.405l-.167.854h-.87a.53.53 0 00-.49.405.33.33 0 00.33.405h.87l-.167.853c-.043.22.109.405.333.405s.447-.187.49-.406l.168-.854h.869a.533.533 0 00.49-.405.327.327 0 00-.33-.404M84.369 13.66a.527.527 0 00-.491.405l-.79 4.02c-.427 2.049-1.707 2.326-2.906 2.326-2.162 0-2.215-1.209-1.982-2.394l.927-4.726a.33.33 0 00-.333-.404.526.526 0 00-.491.404l-.927 4.726c-.188.951-.12 1.662.203 2.172.407.64 1.232.963 2.459.963 1.225 0 2.178-.323 2.836-.963.52-.51.867-1.221 1.055-2.172l.773-3.956a.33.33 0 00-.333-.405M76.923 9.457a.529.529 0 00-.491.405l-2.114 10.789a.328.328 0 00.334.403.526.526 0 00.489-.403l2.114-10.789a.33.33 0 00-.332-.405"
                      />
                    </svg>
                  ) : (
                    ''
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SiteTemplate.propTypes = {
  sitedescription: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
};

const SiteItem = ({ data }) => {
  const { markdownRemark: site } = data;
  return (
    <Layout>
      <SiteTemplate
        image={site.frontmatter.sitehomepageimage.childImageSharp.fluid.src}
        description={site.frontmatter.sitedescription}
        helmet={
          <Helmet titleTemplate="%s | Blog">
            <title>{`${site.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${site.frontmatter.sitedescription}`}
            />
          </Helmet>
        }
        title={site.frontmatter.title}
        siteurl={site.frontmatter.siteurl}
        sitecategory={site.frontmatter.sitecategory}
        sitefburl={site.frontmatter.sitefburl}
        sitetwurl={site.frontmatter.sitetwurl}
        shopifyplus={site.frontmatter.shopifyplus}
      />
    </Layout>
  );
};

SiteItem.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default SiteItem;

export const pageQuery = graphql`
  query SiteRollQueryID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      frontmatter {
        title
        sitedescription
        siteurl
        sitecategory
        sitefburl
        sitetwurl
        shopifyplus
        sitehomepageimage {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
